import { Search } from 'lucide-react';
import { useAuditLog, AuditEntry } from '../../hooks/useAuditLog';
import { Card, DataTable, Avatar } from '../../components/ui';
import type { Column } from '../../components/ui';
import { fmtDT } from '../../utils/helpers';

const columns: Column<AuditEntry>[] = [
  { key: 'createdAt', header: 'When', sortValue: e => new Date(e.createdAt).getTime(),
    render: e => <span className="text-xs text-gray-500 whitespace-nowrap">{fmtDT(e.createdAt)}</span> },
  { key: 'user', header: 'Actor', sortValue: e => e.user?.name ?? '',
    render: e => e.user ? (
      <div className="flex items-center gap-2"><Avatar name={e.user.name} size="sm" /><span className="text-sm">{e.user.name}</span></div>
    ) : <span className="text-gray-400 text-xs">system</span> },
  { key: 'action', header: 'Action', sortValue: e => e.action,
    render: e => <span className="font-mono text-xs px-1.5 py-0.5 rounded bg-gray-100 text-navy">{e.action}</span> },
  { key: 'resource', header: 'Resource', render: e => (
    <span className="text-xs text-gray-500">{e.resourceType}{e.resourceId ? `:${e.resourceId.slice(0, 12)}` : ''}</span>
  ) },
  { key: 'ip', header: 'IP', render: e => <span className="text-xs text-gray-400 font-mono">{e.ipAddress ?? '—'}</span> },
];

export default function AuditLog() {
  const { entries, total, loading, action, setAction } = useAuditLog();

  return (
    <div className="p-5 space-y-4">
      <div>
        <h1 className="text-xl font-bold text-navy">Audit Log</h1>
        <p className="text-sm text-gray-500">{total} recorded actions</p>
      </div>
      <Card flush>
        <div className="p-3 border-b border-gray-100">
          <div className="relative max-w-xs">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input value={action} onChange={e => setAction(e.target.value)} placeholder="Filter by action (e.g. TICKET_APPROVED)"
              className="w-full text-sm rounded-lg border border-gray-300 pl-9 pr-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand/30 focus:border-brand" />
          </div>
        </div>
        <DataTable columns={columns} data={entries} rowKey={e => e.id} loading={loading} pageSize={50}
          emptyTitle="No audit entries" emptyDescription="Actions across the portal will appear here." />
      </Card>
    </div>
  );
}
